import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import { Stack } from '@festina-life/ui/structure'
import cx from 'classnames'

import { OpenScratchpadButton } from '../../components/openScratchpad/OpenScratchpadButton'
import { Search } from '../../components/search/Search'
import { ToggleIconButton } from '../../components/toggleIconButton/ToggleIconButton'
import { useLayoutContext } from '../../context/layoutContext'
import { useConfigurationComponentAvailability } from '../../hooks/useConfigurationComponentAvailability'

export const LeftBar = () => {
  const { preferences, onChangeView } = useLayoutContext()
  const translate = useTranslate()
  const isConfigurationComponentAvailable =
    useConfigurationComponentAvailability()
  const { persona } = useLayoutContext()

  return (
    <Stack
      className={cx('flex-col', paperStyles({ borders: ['right'] }))}
      padding="normal"
    >
      <Stack className="flex-col">
        <ToggleIconButton
          onClick={() =>
            onChangeView({
              ...preferences,
              leftSidebar:
                preferences.leftSidebar === 'picker' ? 'collapsed' : 'picker',
            })
          }
          isActive={preferences.leftSidebar === 'picker'}
          tip={translate('leftBar.button.picker')}
          iconName="Folder"
        />
        <ToggleIconButton
          onClick={() =>
            onChangeView({
              ...preferences,
              leftSidebar:
                preferences.leftSidebar === 'branches'
                  ? 'collapsed'
                  : 'branches',
            })
          }
          isActive={preferences.leftSidebar === 'branches'}
          tip={translate('leftBar.button.branches')}
          iconName="GitBranch"
        />
        {persona === 'ConfigurationAdmin' && (
          <ToggleIconButton
            onClick={() =>
              onChangeView({
                ...preferences,
                leftSidebar:
                  preferences.leftSidebar === 'workspaces'
                    ? 'collapsed'
                    : 'workspaces',
              })
            }
            isActive={preferences.leftSidebar === 'workspaces'}
            tip={translate('leftBar.button.workspaces')}
            iconName="Briefcase"
          />
        )}
      </Stack>
      <div className={cx(paperStyles({ borders: ['top'] }))} />
      <Stack className="flex-col">
        {isConfigurationComponentAvailable && <OpenScratchpadButton />}
        <Search />
      </Stack>
    </Stack>
  )
}
